import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon } from 'lucide-react';
export function RevealSection() {
  return <motion.section initial={{
    opacity: 0
  }} whileInView={{
    opacity: 1
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.6
  }} className="py-20 px-4 bg-gradient-to-b from-black/40 to-transparent" data-id="element-189">
      <div className="max-w-5xl mx-auto text-center" data-id="element-190">
        <motion.div initial={{
        scale: 0.9,
        opacity: 0
      }} whileInView={{
        scale: 1,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mb-8" data-id="element-191">
          <SparklesIcon className="w-16 h-16 text-amber-500 mx-auto mb-4" data-id="element-192" />
          <h2 className="text-2xl md:text-3xl font-black mb-4 text-amber-400" data-id="element-193">
            PRESENTAMOS:
          </h2>
          <h3 className="text-5xl md:text-7xl font-black bg-gradient-to-r from-amber-400 via-amber-500 to-amber-600 bg-clip-text text-transparent mb-8" data-id="element-194">
            THE AI FREELANCE GOLDMINE
          </h3>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-6 text-lg leading-relaxed text-gray-200" data-id="element-195">
          <p data-id="element-196">
            He descubierto que{' '}
            <span className="text-amber-400 font-semibold" data-id="element-197">
              la IA no viene a reemplazarte, viene a servirte.
            </span>{' '}
            He creado un método donde la IA hace el 95% del trabajo técnico
            (escribir, diseñar, editar) y tú solo actúas como el director.
          </p>
          <p data-id="element-198">
            No necesitas ser un experto.{' '}
            <span className="text-amber-400 font-semibold" data-id="element-199">
              Solo necesitas saber qué "botones" apretar.
            </span>{' '}
            Hemos destilado meses de pruebas en un sistema de 3 pasos que te
            permite entregar trabajos de calidad profesional a clientes en USA
            que están desesperados por ayuda... y que pagan muy bien.
          </p>
        </motion.div>
      </div>
    </motion.section>;
}